import React, { PropsWithChildren, useMemo } from 'react'
import { FiChevronRight } from 'react-icons/fi'
import { ProductByHandleQuery } from 'storefront'
import { Rating } from './reviews/Rating'
import Icon from '../Icon'

interface Props {
  data: ProductByHandleQuery['product']
  selectInfo: any
  className?: string
  children?: any
  openShare?: boolean
  reviews?: any
  onShare?: (e?: any) => any
}
const ProductsMeta = ({
  data,
  selectInfo,
  className,
  children,
  openShare = true,
  reviews,
  onShare,
}: PropsWithChildren<Props>) => {
  // const [showDiscount, setShowDiscount] = useState<boolean>(false)
  function goReviewsSection() {
    const location = document.querySelector?.('.reviews-wrapper') as HTMLElement
    if (location) {
      // console.log(location?.offsetTop)
      window?.scrollTo(0, location?.offsetTop - 100)
    }
  }
  function handelPercent() {
    const { price, compareAtPrice } = selectInfo
    return `${Math.round((1 - price / compareAtPrice) * 100)}%`
  }
  const showDiscount = useMemo(() => {
    const { price, compareAtPrice } = selectInfo
    if (
      selectInfo &&
      compareAtPrice &&
      Number(compareAtPrice) > Number(price)
    ) {
      return true
    }
    return false
  }, [selectInfo, data])
  return (
    <div
      className={`product-meta px-3 md:px-0 pb-4 ${className || ''}`}
      key={data?.handle}
    >
      <h2 className="text-black flex justify-between items-center text-sm md:text-xl md:font-bold leading-tight">
        <span className=" text-gray-500 font-medium md:text-gray-900 mt-3 mb-2.5">
          {data?.title}
        </span>
        {openShare && (
          <span
            className="openShare cursor-pointer block md:hidden"
            onClick={onShare}
          >
            <Icon name="share" />
          </span>
        )}
      </h2>
      {/* {JSON.stringify(selectInfo)} */}
      <div className="flex justify-between items-center">
        <div className="flex items-center">
          <span
            className={`font-semibold md:font-bold text-22 md:text-2xl ${
              showDiscount ? 'text-tag-red' : ''
            }`}
          >
            ${selectInfo?.price}
          </span>
          {showDiscount && (
            <span className="text-sm line-through mx-1.5 text-gray-600">
              ${selectInfo?.compareAtPrice}
            </span>
          )}
          {showDiscount && (
            <span className="bg-tag-red text-xss text-white h-3.5 px-1 inline-flex justify-center items-center font-semibold">
              -{handelPercent()}
            </span>
          )}
        </div>
        {reviews?.rating > 0 && (
          <div
            className="text-xs text-gray-500 md:hidden flex items-center whitespace-nowrap cursor-pointer"
            onClick={() => {
              goReviewsSection()
              window.localStorage.setItem('review_from', '2')
            }}
          >
            <Rating
              type="outline"
              value={reviews?.rating}
              length={5}
              openHalf
              func={(v: number) => Math[v < 4.8 ? 'floor' : 'ceil'](v * 2) / 2}
              className="star-xs"
            />
            <span className="pl-1">({reviews?.total})</span>
            <FiChevronRight size={15} color="#999999" />
          </div>
        )}
      </div>
      {children}
    </div>
  )
}

export default ProductsMeta
